{
  "id": "simples-nacional",
  "nome": "LC 123/2006 — Simples Nacional (anexos e faixas)",
  "fonte": "Lei Complementar 123/2006 — Anexos I a V (redação LC 155/2016)",
  "endpoints": [
    "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp123.htm",
    "http://normas.receita.fazenda.gov.br/sijut2consulta/anexoOutros.action?idArquivoBinario=48430",
    "http://normas.receita.fazenda.gov.br/sijut2consulta/link.action?visao=anotado&idAto=115262"
  ],
  "capturadoEm": "2026-06-25",
  "atualizadoEm": "2026-06-25T13:34:24.570Z",
  "contagens": {
    "anexos": 5,
    "faixas": 30
  },
  "alteracoes": {
    "adicionados": 0,
    "removidos": 0,
    "alterados": 0,
    "comparadoCom": "2026-06-25"
  },
  "verificacao": {
    "agendamento": "manual",
    "workflow": "data-refresh-bot.yml",
    "ultimaExecucao": "2026-06-25T13:34:24.570Z"
  },
  "documentacao": "docs/OFFICIAL-SOURCES.md#simples-nacional-anexos"
}
